module.exports = __webpack_public_path__ + "static/NeueEODisplay65Medium-e49edf17258f213b31174d7f1789d588.woff";